import 'css-chunksrc/client/pages/projectPage/timeSheetPage/filters/filterOptions/styles.scss';export default {
  "optionsFilter": "_optionsFilter_1i84v_1",
  "input": "_input_1i84v_7",
  "toggleArrow": "_toggleArrow_1i84v_24",
  "selectedOptions": "_selectedOptions_1i84v_32",
  "placeholder": "_placeholder_1i84v_41",
  "list": "_list_1i84v_46",
  "item": "_item_1i84v_58",
  "typeName": "_typeName_1i84v_71",
  "opened": "_opened_1i84v_78"
};